export default __webpack_public_path__ + "static/mentees-bfe64363c608ffb563e9a45f27454166.webp";